import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../utils/axiosConfig';
import MarcajesPanel from '../MarcajesPanel';
import { display } from '../ui';

// Cada marcaje tal como llegó del aparato, para revisar o auditar
const MarcajesVista = () => {
    const [aparatos, setAparatos] = useState([]);
    useEffect(() => {
        axiosInstance.get('/api/asistencia/configuracion/aparatos').then(({ data }) => setAparatos(data.aparatos)).catch(() => {});
    }, []);
    return (
        <div className="space-y-6">
            <header>
                <h1 className={`${display} text-3xl font-bold text-slate-900`}>Marcajes</h1>
                <p className="text-sm text-slate-500 mt-1">
                    Cada marca tal como llegó del aparato.
                </p>
            </header>
            <MarcajesPanel aparatos={aparatos} />
        </div>
    );
};

export default MarcajesVista;
